import {ApiClient} from '@hconnect/apiclient'
import {useQuery} from '@tanstack/react-query'

import {ApiFilter, AutocompleteOption} from '../filter.types'

export type DistinctValue = {
  id?: string
  value: string
  displayValue?: string
}

export type DistinctValuesResponse = {
  currentPage: number
  totalCount: number
  data: DistinctValue[]
}

export const QueryKey = 'distinct-analysis-vals'

export type UseDistinctListProps = {
  id: string
  apiUrl: string
  filters?: ApiFilter[]
  apiParams?: object
}

export const useDistinctListValues = ({id, apiUrl, filters, apiParams}: UseDistinctListProps) => {
  return useQuery({
    queryKey: [QueryKey, id, apiUrl, filters, apiParams],
    queryFn: async () => {
      return (
        await ApiClient.axiosInstance.post<DistinctValuesResponse>(
          apiUrl,
          {pageSize: null, pageNumber: 0, property: id, filters: filters, ...apiParams},
          {}
        )
      ).data
    },
    // these default values will get moved to the api provider soon
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    throwOnError: true,
    retry: false,
    select: (data) => generateOptions(data.data)
  })
}

const generateOptions = (data: DistinctValue[]) => {
  const autocompleteOptions: AutocompleteOption[] = []
  const processedValues = new Set<string>()

  data.forEach((option) => {
    const id = option.value
    const value = option.displayValue ?? option.value

    if (processedValues.has(value)) return
    processedValues.add(value)

    autocompleteOptions.push({
      id: id,
      label: value
    })
  })

  return autocompleteOptions
}
